import s1 from '../assets/s1.jpg'
import s2 from '../assets/s2.jpg'
import s4 from '../assets/s4.jpg'
import s7 from '../assets/s7.png'
import ssss6 from '../assets/ssss6.jpg'
import sssssssss5 from '../assets/sssssssss5.png'
import c6 from '../assets/c6.png'
import c5 from '../assets/c5.png'
import c1 from '../assets/c1.jpg'
import c2 from '../assets/c2.jpg'
import c3 from '../assets/c3.jpg'


const choice = {
    title: "Top Choices",
    items: [
        {
            img: s7, 
            id: "1",
            title: "Nike Air Low Premium",
            text: "MEN Running Shoes",
            price: "150",
        },
        {
            img: s1, 
            id: "22",
            title: "Nike Air Low Premium",
            text: "MEN Running Shoes",
            price: "150",
        },
        {
            img: s2, 
            id: "13",
            title: "Nike Air Low Premium",
            text: "MEN Running Shoes",
            price: "150",
        },
        {
            img: s4, 
            id: "14",
            title: "Nike Air Low Premium",
            text: "MEN Running Shoes",
            price: "150",
        },
        {
            img: ssss6, 
            id: "15",
            title: "Nike Air Low Premium",
            text: "MEN Running Shoes",
            price: "150",
        },
        {
            img: sssssssss5, 
            id: "16",
            title: "Nike Air Low Premium",
            text: "MEN Running Shoes",
            price: "150",
        },
        {
            img: c1,
            id: "178",
            title: "Nike Air Low Premium",
            text: "MEN Running Shoes",
            price: "150",
        },
        {
            img: c2,
            id: "18",
            title: "Nike Air Low Premium",
            text: "MEN Running Shoes",
            price: "150",
        },
        {
            img: c3,
            id: "8",
            title: "Nike Air Low Premium",
            text: "MEN Running Shoes",
            price: "150",
        },
        {
            img: c5,
            id: "9",
            title: "Nike Air Low Premium",
            text: "MEN Running Shoes",
            price: "150",
        },
        {
            img: c6,
            id: "10",
            title: "Nike Air Low Premium",
            text: "MEN Running Shoes",
            price: "150",
        },
    ]
};

export default choice;